var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5759_24742",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17204 9.99992L7.8387 5.33325L12.5054 9.99992"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8387 5.33325L8.82865 4.3433C8.28192 3.79657 7.39549 3.79657 6.84875 4.3433L7.8387 5.33325ZM4.16199 10.9899L8.82865 6.3232L6.84875 4.3433L2.18209 9.00997L4.16199 10.9899ZM6.84875 6.3232L11.5154 10.9899L13.4953 9.00997L8.82865 4.3433L6.84875 6.3232Z",
    fill: "#AEB1B8",
    mask: "url(#path-1-inside-1_5759_24742)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.1e1ce8501c62232393b029b4df81dbcf.svg";
export { ForwardRef as ReactComponent };